/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Toast_SubmittedInputs */

const en_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesson booked.`)
};

const es_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lección reservada.`)
};

const de_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfstunde gebucht.`)
};

const zh_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程已预订。`)
};

const ar_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم حجز الدرس.`)
};

const fr_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leçon réservée.`)
};

const vi_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đặt buổi học.`)
};

const sw_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nafasi ya somo imewekwa.`)
};

const th_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองบทเรียนแล้ว`)
};

const bs_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcija je rezervisana.`)
};

const ja_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンを予約しました。`)
};

const ko_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨이 예약되었습니다.`)
};

const pt_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aula reservada.`)
};

const it_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezione prenotata.`)
};

const sv_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektionen är bokad.`)
};

const nl_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les geboekt.`)
};

const da_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektion reserveret.`)
};

const nb_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timen er bestilt.`)
};

const fi_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppitunti varattu.`)
};

const pl_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcja zarezerwowana.`)
};

const ru_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Урок забронирован.`)
};

const tr_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders rezervasyonunuz alındı.`)
};

const hi_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ बुक हो गया।`)
};

const id_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran dipesan.`)
};

const ms_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran ditempah.`)
};

const cs_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekce zarezervována.`)
};

const el_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το μάθημα έκλεισε.`)
};

const he_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השיעור הוזמן.`)
};

const af_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les bespreek.`)
};

const hu_booking_toast_submitted = /** @type {(inputs: Booking_Toast_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az órát lefoglaltuk.`)
};

/**
* | output |
* | --- |
* | "Lesson booked." |
*
* @param {Booking_Toast_SubmittedInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_toast_submitted = /** @type {((inputs?: Booking_Toast_SubmittedInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Toast_SubmittedInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_toast_submitted(inputs)
	if (locale === "de") return de_booking_toast_submitted(inputs)
	if (locale === "zh") return zh_booking_toast_submitted(inputs)
	if (locale === "ar") return ar_booking_toast_submitted(inputs)
	if (locale === "fr") return fr_booking_toast_submitted(inputs)
	if (locale === "vi") return vi_booking_toast_submitted(inputs)
	if (locale === "sw") return sw_booking_toast_submitted(inputs)
	if (locale === "th") return th_booking_toast_submitted(inputs)
	if (locale === "bs") return bs_booking_toast_submitted(inputs)
	if (locale === "ja") return ja_booking_toast_submitted(inputs)
	if (locale === "ko") return ko_booking_toast_submitted(inputs)
	if (locale === "pt") return pt_booking_toast_submitted(inputs)
	if (locale === "it") return it_booking_toast_submitted(inputs)
	if (locale === "sv") return sv_booking_toast_submitted(inputs)
	if (locale === "nl") return nl_booking_toast_submitted(inputs)
	if (locale === "da") return da_booking_toast_submitted(inputs)
	if (locale === "nb") return nb_booking_toast_submitted(inputs)
	if (locale === "fi") return fi_booking_toast_submitted(inputs)
	if (locale === "pl") return pl_booking_toast_submitted(inputs)
	if (locale === "ru") return ru_booking_toast_submitted(inputs)
	if (locale === "tr") return tr_booking_toast_submitted(inputs)
	if (locale === "hi") return hi_booking_toast_submitted(inputs)
	if (locale === "id") return id_booking_toast_submitted(inputs)
	if (locale === "ms") return ms_booking_toast_submitted(inputs)
	if (locale === "cs") return cs_booking_toast_submitted(inputs)
	if (locale === "el") return el_booking_toast_submitted(inputs)
	if (locale === "he") return he_booking_toast_submitted(inputs)
	if (locale === "af") return af_booking_toast_submitted(inputs)
	if (locale === "hu") return hu_booking_toast_submitted(inputs)
	return en_booking_toast_submitted(inputs)
});